import React, { Component } from "react";
import SharedViewProps from "../../../../shared/SharedViewProps";
import CancelCheckDialogView from "./components/CancelCheckDialog/CancelCheckDialogView";
import CancelCheckDialogViewState from "./components/CancelCheckDialog/CancelCheckDialogViewState";
import Service from "../../../../../network/Service";
import Application from "../../../../Application";

export default class CancelCheckView extends Component<SharedViewProps> {

    service = new Service();

    state = {
        error: undefined,
        queryParams: new URLSearchParams(this.props.routeProps.location.search)
    };

    render() {
        return (
            <CancelCheckDialogView onSubmit={this.onSubmit} error={this.state.error} />
        );
    }

    onSubmit = async (formData: CancelCheckDialogViewState, done: () => void) => {
        const checkId = this.state.queryParams.get('checkId');
        const superiorId = this.state.queryParams.get('superiorId');

        if (checkId && superiorId) {
            this.setState({ error: undefined });
            const { error } = await this.service.cancelCheck(checkId, {
                superiorId: superiorId,
                comment: formData.comment
            });

            if (!error) {
                this.props.routeProps.history.push(`/${Application.language}/forms/submit-success`, {
                    origin: 'cancel-check'
                });
            }

            else {
                this.setState({ error: 'genericError' });
                done();
            }
        }

        else {
            this.setState({ error: 'genericError' });
            done();
        }
    }
}